$(document).ready(function(){
    $('.mi_btn').mouseover(function(){
        $(this).addClass('hovered');
    });

    $('.mi_btn').mouseleave(function(){
        $(this).removeClass('hovered');
    });


    // Carousels
    $('.mi_hero_carousel').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        arrows: true,
        dots: true
    });

    $('.mi_about_carousel').slick({
        infinite: true,
        slidesToShow: 4,
        arrows: true,
        dots: true,
        autoplay: true,
        responsive: [
            {
              breakpoint: 678,
              settings: {
                slidesToShow: 1
              }
            }
        ]
    });

    $(document).on("click",".mi_carousel_next",function() {
        $(this).closest('.mi_outer').find('.slick-next').trigger('click');
    });

    $(document).on("click",".mi_carousel_prev",function() {
        $(this).closest('.mi_outer').find('.slick-prev').trigger('click');
    });

    $('.mi_menu_drawer__open').click(function(evt){
        evt.preventDefault();
        $('.mi_menu_drawer__open').removeClass('active');
        
        var currentData = $(this).attr('data-id');
        if ( $('.mi_menu_item__js[data-id="'+currentData+'"]').hasClass('opened')){
            $('.mi_menu_item__js').slideUp();
            $('.mi_menu_item__js').removeClass('opened');
        }
        else{
            $('.mi_menu_item__js').slideUp();
            $('.mi_menu_item__js').removeClass('opened');
            $('.mi_menu_item__js[data-id="'+currentData+'"]').slideDown();
            $('.mi_menu_item__js[data-id="'+currentData+'"]').addClass('opened');
            $(this).addClass('active');
        }
        
    });

    $('.mi_outer').click(function(){
        $('.mi_menu_item__js').slideUp();
    });

    $('.mi_product_meta_collap').click(function(){
        $(this).toggleClass('active');
        $(this).find('.mi_product_meta_collap_content').slideToggle();
    });

    $('.mi_popup_close').click(function(){
        $('.mi_product_popup_outer').hide();
    });


    $('.mi_product_desc_morepr').click(function(){
        var currentHtml = $(this).html();
        if (String(currentHtml).indexOf('daugiau') != -1){
            $('.mi_product_desc_morepr').html('Rodyti mažiau');
        }
        else{
            $('.mi_product_desc_morepr').html('Skaityti daugiau');
        }
        $('.mi_product_full_descrition').toggle();
        $('.mi_product_short_descrition').toggle();
    });

    $('.mi_product_desc_more').click(function(){
      if ($(this).hasClass('relative')){
        var dataId = $(this).attr('data-id');
        $('.mi_product_popup_outer[data-id="'+dataId+'"]').css('display', 'flex');
      }
      else{
        $('.mi_product_popup_outer').css('display', 'flex');
      }
        
    });

    
    $(document).on("click",".mi_btn_atc_col",function(evt) {
        evt.preventDefault();
        var currentId = $(this).attr('data-id');
        var currentQty = 1;

        var data = {
            id: currentId,
            quantity: currentQty
        };

        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              refreshCart();
            },
        });

    });

  
  $(document).on("click",".mi_atc_button_main",function(evt) {
        evt.preventDefault();
        var currentId = $(this).attr('data-id');
        var currentQty = $('.quantity-selector__input').val();

        var data = {
            id: currentId,
            quantity: currentQty
        };

        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              refreshCart();
            },
        });

    });

    $(document).on("click",".mi_btn.mi_atc_quick",function(evt) {
        evt.preventDefault();
        var currentId = $(this).attr('data-id');
        var currentQty = 1;

        var data = {
            id: currentId,
            quantity: currentQty
        };

        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              refreshCart();
            },
        });

    });

    function  refreshCart(){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
        }));
        const cartDrawer = document.querySelector('cart-drawer'); 
        cartDrawer.show();
    }


    $('.shopify-product-form').find('input[name="id"]').change(function(){
        var currentId = $(this).val();
        $('.pp_meta_information').hide();
        $('.pp_meta_information[data-id="'+currentId+'"]').show();
    });

    $(document).on("click",".mi_footer_container_box.dropdowned",function() {
        $(this).toggleClass('active');
        $(this).find('.mi_footer_menu_box').slideToggle();
    });

    $(document).on("click",".pagination__link",function() {
        $("html, body").animate({ scrollTop: 0 }, "fast");
        return false;
    });
    

});